/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { Button, Tag, Modal, Divider } from 'antd'
import { useSelector } from 'react-redux'
import { nanoid } from 'nanoid'

import { useParams } from 'react-router-dom'
import FadeIn from 'react-fade-in'
import Loader from 'react-loader-spinner'
import moment from 'moment'
import DOMPurify from 'dompurify'
import { useTranslation } from 'react-i18next'
import {
  contractColors,
  generateJ2BDSoftApplyUrl,
  generateSoftApplyUrl,
} from '../../../utils'
import * as s from './styles'

import { getJob } from '../../../services/companyService'
import { BASE_APPLY_URL } from '../../../services/CONSTANTS'
import JobInformation from './JobInformation'

export default () => {
  const { t } = useTranslation(['careers'], {
    useSuspense: false,
  })

  const params = useParams()
  const primaryColor = useSelector((state) => state.company.theme.primaryColor)
  const [chatbotOpen, setChatbotOpen] = useState(false)
  const [chatbotLoading, setChatbotLoading] = useState(true)
  const [job, setJob] = useState({})

  const handleCloseChatbot = () => {
    setChatbotOpen(false)
    setChatbotLoading(true)
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    getJob(params.jobId)
      .then((result) => {
        setJob(result)
      })
      .catch((e) => {
        console.error(e)
      })
  }, [params.jobId])

  const createMarkup = (html) => ({
    __html: DOMPurify.sanitize(html),
  })

  if (!Object.keys(job).length) {
    return (
      <div
        style={{ display: 'flex', justifyContent: 'center', marginTop: '25%' }}
      >
        <Loader type="TailSpin" color="#0f6fde" height={30} width={30} />
      </div>
    )
  }

  return (
    <s.JobDetailWrapper>
      {chatbotOpen ? (
        <Modal
          onOk={handleCloseChatbot}
          onCancel={handleCloseChatbot}
          style={{
            padding: '0!important',
            top: window.screen.width <= 480 ? 0 : 80,
          }}
          visible
          maskTransitionName=""
          width={1180}
          footer={null}
        >
          <div className="container rsvp-wrapper">
            <iframe
              title="chatbot candidature"
              width="100%"
              height="700"
              onLoad={() =>
                window.setTimeout(() => setChatbotLoading(false), 500)
              }
              style={{
                backgroundColor: 'white',
                opacity: chatbotLoading ? '0' : '1',
                transition: '.2s ease all',
              }}
              src={`${BASE_APPLY_URL}/${job._id}`}
            />
          </div>
        </Modal>
      ) : (
        <FadeIn key={nanoid()}>
          <header className="jobDetailHeaderWrapper">
            <div>
              <h2>
                {job.displayName || job.name}
                {/* <Tag color={contractColors[job.contractType]}>
                  {job.contractType}
                </Tag> */}
              </h2>
              <JobInformation job={job} />
            </div>

            <Button
              style={{ backgroundColor: primaryColor }}
              onClick={() => {
                if (job.applicationType === 'full') {
                  setChatbotOpen(true)
                } else {
                  window.open(
                    params?.companyName === 'j2bd'
                      ? generateJ2BDSoftApplyUrl(job)
                      : generateSoftApplyUrl(job),
                    '_blank',
                    'noopener,noreferrer',
                  )
                }
              }}
            >
              {t('careers:jobDetails.apply')}
            </Button>
          </header>

          <Divider />
          {job.clientDescription && (
            <div className="description" style={{ marginTop: '50px' }}>
              <h3>{t('careers:jobDetails.company')}</h3>
              <div
                className="preview"
                dangerouslySetInnerHTML={createMarkup(job.clientDescription)}
              />
            </div>
          )}

          {job.description && (
            <div className="description" style={{ marginTop: '50px' }}>
              <h3>{t('careers:jobDetails.description')}</h3>
              <div
                className="preview"
                dangerouslySetInnerHTML={createMarkup(job.description)}
              />
            </div>
          )}
          {job.candidateDescription && (
            <div className="description" style={{ marginTop: '50px' }}>
              <h3>{t('careers:jobDetails.profile')}</h3>
              <div
                className="preview"
                dangerouslySetInnerHTML={createMarkup(job.candidateDescription)}
              />
            </div>
          )}

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Button
              style={{ backgroundColor: primaryColor }}
              onClick={() => {
                if (job.applicationType === 'full') {
                  setChatbotOpen(true)
                } else {
                  window.open(
                    params?.companyName === 'j2bd'
                      ? generateJ2BDSoftApplyUrl(job)
                      : generateSoftApplyUrl(job),
                    '_blank',
                    'noopener,noreferrer',
                  )
                }
              }}
            >
              {t('careers:jobDetails.apply')}
            </Button>
          </div>
        </FadeIn>
      )}
    </s.JobDetailWrapper>
  )
}
